/**
 * Datas como o arquivo as declara (E84.F2): com segundos e com o fuso declarado, sem
 * converter para o fuso do navegador — converter esconderia o "fuso não declarado" que
 * o laudo precisa dizer. Módulo próprio desde a E97.F4.T04: o painel do arquivo e o
 * vestígio de assinatura formatam do mesmo jeito, sem um componente importar o outro.
 */
import { ptBR } from '@/i18n/pt-BR';

const ta = ptBR.exameEletronico.quadro.arquivo;

const ISO_DECLARADO =
  /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?(Z|[+-]\d{2}:\d{2})?$/;

/** `dd/mm/aaaa hh:mm:ss (UTC±hh:mm)`, ou o texto de fuso não declarado. */
export function formatarDeclarado(iso: string | null | undefined): string {
  if (!iso) return ta.naoInformado;
  const partes = ISO_DECLARADO.exec(iso);
  if (!partes) return iso;
  const [, ano, mes, dia, hora, minuto, segundo = '00', fuso] = partes;
  const base = `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
  if (!fuso) return `${base} (${ta.semFuso})`;
  return `${base} (UTC${fuso === 'Z' ? '+00:00' : fuso})`;
}
